import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const FeedbackPage = lazy(() => import("./FeedbackPage"));

const FeedbackPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <FeedbackPage />
    </Suspense>
  );
};

export default FeedbackPageLazy;
